/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

// Redux Store
import { ControlTable } from "../../components/Table";
import { getParams } from "../../utils/params";
import { get } from "lodash";
import { isEmpty } from "lodash-es";
import {
  COMPANY_TYPE, COMPANY_SEP
  // ,COMPANY_STATE
} from "../../constants/COMPANY";
import useForm from "../../hooks/useForm";
import { transformComNum } from "../../utils/validator/comNum";
import Filters from "../Filters";
import { useSelector } from "react-redux";

import Modal, { ModalHeader } from "../Modal";
import Managers from "../Manager/Mangers";
import Pertner from "./Partner";
import MangerCompany from "../Manager/ManagerCompay";
import { getThroughMeCompanyAllList } from "../../apis/companies/companies";


const PartnerThroughMeCompanies = () => {

  const [managerViewCompany, setManagerViewCompany] = useState(null);
  const [selectedPartnerCompnay, setSelectedPartnerCompnay] = useState(null);
  const [careCompany, setCareCompany] = useState(null);
  const [fields, setFields] = useState([]);


  const { company } = useSelector((store) => store.Profile);

  useEffect(() => {
    if (!isEmpty(company)) {
      setFields([
        { title: "회사타입", label: '-', key: "type", onTranslator: { list: COMPANY_TYPE } },
        { title: "회사명", label: '-', key: "name" },
        { title: "구분", label: '-', key: "sep", onTranslator: { list: COMPANY_SEP } },
        {
          title: "사업자번호", label: '-', key: "comNum", onValue: (value) => {
            return transformComNum(value);
          }
        },
        { title: "대표자명", label: '-', key: "ceoName" },
        // { title: "승인 상태", label: '-', key: "state", onTranslator: { list: COMPANY_STATE } },
        // { title: "등록일자", label: '-', key: "createdTime", type: 'dateTime' },
      ]);
    }
  }, [company]);

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    reSubmit,
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      searchType: 'name',
      searchText: '',
      order: [
        {
          idx: "desc"
        },
      ],
      page: 0,
      limit: 10
    },
  );


  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  const submit = (param) => {
    getThroughMeCompanyAllList({
      ...getParams(param)
    })
      .then((res) => {
        setTotal(get(res, "data.total"));
        setList(get(res, "data.companies"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
        setSelectedList([]);
      });
  };


  const [filters] = useState([
    {
      title: "상호",
      key: "search.name",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "사업자번호",
      key: "search.comNum",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "대표이름",
      key: "search.ceoName",
      options: {
        placeholder: "검색어 입력",
      },
    },
  ]);


  return (
    <>

      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        title={'홈페이지를 통해 유입된 고객 목록'}
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
      // isControl={false}
      />

      <Modal
        isOpen={!!managerViewCompany}
        close={() => {
          setManagerViewCompany(null);
          reSubmit();
        }}
      >
        {managerViewCompany && (
          <>
            <ModalHeader>{managerViewCompany.name} 매니저 관리</ModalHeader>
            <Managers targetCompany={managerViewCompany}></Managers>
          </>
        )}
      </Modal>
      <Modal
        isOpen={!!selectedPartnerCompnay}
        close={() => {
          setSelectedPartnerCompnay(null);
          reSubmit();
        }}
      >
        {selectedPartnerCompnay && (
          <>
            <Pertner partnerCompany={selectedPartnerCompnay} />
          </>
        )}
      </Modal>

      {!isEmpty(company) && !isEmpty(careCompany) && (
        <MangerCompany
          open={!!careCompany}
          setOpen={() => { setCareCompany(null); }}
          list={[company]}
          type={company.type}
          myCareCompany={careCompany}
          submit={reSubmit}
        />
      )}
    </>
  );
};

export default PartnerThroughMeCompanies;